import type { BargeldlosSchule } from './bargeldlosApi.ts'
import { formatDateDE, isoToday } from './office.ts'

/** Add a calendar day to Berlin's date, not 24 hours to the current instant (DST). */
export function bargeldlosDefaultAb(now = new Date()): string {
  const date = new Date(`${isoToday(now)}T12:00:00Z`)
  date.setUTCDate(date.getUTCDate() + 1)
  return date.toISOString().slice(0, 10)
}

export function bargeldlosStateText(
  school: Pick<BargeldlosSchule, 'bargeldlos' | 'seit'>,
  labels: { cash: string; cashless: string; since: (date: string) => string },
): string {
  if (!school.bargeldlos) return labels.cash
  return school.seit ? labels.since(formatDateDE(school.seit)) : labels.cashless
}

export function bargeldlosErrorKey(error: unknown): string {
  if (error && typeof error === 'object') {
    const { code, status } = error as { code?: unknown; status?: unknown }
    if (typeof code === 'string' && ['AB_ZU_FRUEH', 'TAGE_VORHANDEN', 'UEBERLAPPUNG', 'UNGUELTIG', 'NICHT_GEFUNDEN', 'NICHT_VERFUEGBAR'].includes(code)) {
      return `bargeldlos.errors.${code}`
    }
    if (status === 401) return 'bargeldlos.errors.session'
    if (status === 403) return 'bargeldlos.errors.permission'
  }
  return 'bargeldlos.errors.failed'
}
